/**
 * Role Name register here
 */
export enum role {
  propertyManagerAdmin = 'PropertyManagerAdmin',
  propertyManagerUser = 'PropertyManagerUser',
  installerAdmin = 'InstallerAdmin',
  installerUser = 'InstallerUser',
  endUser = 'EndUser',
}

/**
 * Active roles register here
 */
export const activeRoles: role[] = [
  role.propertyManagerAdmin,
  role.propertyManagerUser,
  role.installerAdmin,
];

export interface UserAccess {
  name:
    | role.propertyManagerAdmin
    | role.propertyManagerUser
    | role.installerAdmin
    | role.installerUser
    | role.endUser;
  create: boolean;
  update: boolean;
  view: boolean;
  delete: boolean;
}
export interface UserRoleAccess {
  roleName:
    | role.propertyManagerAdmin
    | role.propertyManagerUser
    | role.installerAdmin
    | role.installerUser
    | role.endUser;
  users: UserAccess[];
}

export const UserRightsAccessControl: UserRoleAccess[] = [
  {
    roleName: role.propertyManagerAdmin,
    users: [
      {
        name: role.propertyManagerAdmin,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.propertyManagerUser,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.installerAdmin,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.installerUser,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.endUser,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
    ],
  },
  {
    roleName: role.propertyManagerUser,
    users: [
      {
        name: role.propertyManagerAdmin,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.propertyManagerUser,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
      {
        name: role.installerAdmin,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.installerUser,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.endUser,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
    ],
  },
  {
    roleName: role.installerAdmin,
    users: [
      {
        name: role.propertyManagerAdmin,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.propertyManagerUser,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.installerAdmin,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
      {
        name: role.installerUser,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.endUser,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
    ],
  },
  {
    roleName: role.installerUser,
    users: [
      {
        name: role.propertyManagerAdmin,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.propertyManagerUser,
        create: true,
        update: true,
        view: true,
        delete: true,
      },
      {
        name: role.installerAdmin,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
      {
        name: role.installerUser,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
      {
        name: role.endUser,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
    ],
  },
  {
    roleName: role.endUser,
    users: [
      {
        name: role.propertyManagerAdmin,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.propertyManagerUser,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.installerAdmin,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.installerUser,
        create: false,
        update: false,
        view: false,
        delete: false,
      },
      {
        name: role.endUser,
        create: false,
        update: false,
        view: true,
        delete: false,
      },
    ],
  },
];
